// extracted by mini-css-extract-plugin
export var headerCell = "_65-1";
export var loadingSpinnerContainer = "_65-4";
export var rowWrapper = "_65-3";
export var standaloneTable = "_65-5";
export var table = "_65-0";
export var white = "_65-2";